import MuiChip from "@mui/material/Chip";

const Tag = MuiChip;

export default Tag;
